import EmailField from '../FirstSignup/components/EmailField/EmailField'
import BusinessLicenseField from '../FirstSignup/components/FileUploadField/BusinessLicenseField'
import SelectField from '../FirstSignup/components/SelectField/SelectField'
const SignupInfos = [
	{
		name: 'email',
		component: EmailField,
		label: '이메일',
		placeholder: '이메일@email.com',
		validationType: 'email', // validation 묶기
		showCheckButton: true,
		/*
		onCheck: { handleEmailCheck },
		checkResult: { emailCheckResult },
        */
	},
	{
		name: 'password',
		label: '비밀번호',
		placeholder: '비밀번호를 입력해주세요',
		validationType: 'password',
	},
	// {
	// 	name: 'lastname',
	// 	label: '영문 성(Last name)',
	// 	placeholder: '대회에 사용되는 영어 성을 입력해주세요',
	// 	validationType: 'english',
	// },
	// {
	// 	name: 'firstname',
	// 	label: '영문 이름(First name)',
	// 	placeholder: '대회에 사용되는 영어 이름을 입력해주세요',
	// 	validationType: 'english',
	// },
	{
		name: 'proCareer',
		label: '경력',
		component: SelectField,
		type: 'dropdown',
		placeholder: '경력을 선택해주세요',
		options: [
			{ value: 'NEWBIE', label: '신입(1년 미만)' },
			{ value: 'ONE_TO_THREE', label: '1년 ~ 3년차' },
			{ value: 'FOUR_TO_SIX', label: '4년 ~ 6년차' },
			{ value: 'OVER_TEN', label: '10년 이상' },
		],
	},
	{
		name: 'caddieTeam',
		label: '캐디구단',
		component: SelectField,
		type: 'dropdown',
		optional: true,
		placeholder: '캐디구단을 선택해주세요',
		validationType: 'optional',
		options: ['스포이음', '보이스캐디', '만수정', '기타'],
	},
	// {
	// 	name: 'agency',
	// 	label: '에이전시',
	// 	component: SelectField,
	// 	type: 'dropdown',
	// 	optional: true,
	// 	placeholder: '에이전시를 선택해주세요',
	// 	validationType: 'optional',
	// 	options: ['에이전시1', '에이전시2', '에이전시3', '기타'],
	// },
	// {
	// 	name: 'businessLicense',
	// 	label: '사업자등록증',
	// 	component: BusinessLicenseField,
	// 	type: 'file',
	// 	optional: true,
	// 	placeholder: '파일을 업로드해주세요',
	// 	validationType: 'businessLicense',
	// },
]

export default SignupInfos
